import { Grid, Typography, Container, makeStyles, Paper, Button } from '@material-ui/core'
import { FC, useEffect, useMemo, useState } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import useChecklist from '../../component/web/shareLogic/useChecklist'
import useLoading from '../../control/loading/useLoading'
import useTranslate from '../../i18n/useTranslate'
import { RoutePath } from '../../router/routesConfig'
import useAuthenStore from '../../stores/authen/authenStore'
import { encryptionAES } from '../../utilities/encryption'

type CommentTopicType = {
    id: number
    no: number
    name_th: string
    name_en: string
    irb: number
}

const ManageCheckList: FC<{}> = () => {
    const [commentatyTopic, setCommentaryTopic] = useState<CommentTopicType[]>([])

    const translate = useTranslate()
    const classes = useStyles()
    const loadingHook = useLoading()
    const history = useHistory()
    const { getAllTopic } = useChecklist()
    const authenStore = useAuthenStore()

    const handleClickToEditForm = (topicID: number) => {
        const encryptedtopicID = encryptionAES(topicID.toString())

        const path = generatePath(RoutePath.addEditCheckList, {
            topicID: encryptedtopicID,
        })

        history.push({
            pathname: path,
            state: {
                topicID: topicID,
            },
        })
    }

    const getLut = (data: any, languageKey: string, enKey: string, thKey: string) => {
        return data?.map((data: any) => ({
            id: data.id,
            name: languageKey === translate.languageKey.en ? data[enKey] : data[thKey],
        }))
    }
    const commentatyLutTopic = useMemo(
        () => getLut(commentatyTopic, translate.languageStore.currentLanguage, 'name_en', 'name_th'),
        [commentatyTopic, translate.languageStore.currentLanguage],
    )

    useEffect(() => {
        const allTopic = async () => {
            loadingHook.loadingOpen()
            const topic = await getAllTopic(Number(authenStore.profile.irb))
            setCommentaryTopic(topic.result)
            loadingHook.loadingClose()
        }

        allTopic()
    }, [])
    return (
        <Container maxWidth="lg">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h5" className={classes.titleContainer}>
                        {translate.get('LABEL.MANAGE_CHECKLIST')}
                    </Typography>
                </Grid>
            </Grid>

            {commentatyLutTopic.map((topic: { id: number; name: string }) => {
                return (
                    <Paper className={classes.paper} variant="outlined" key={topic.id}>
                        <Grid container spacing={2} justify="space-between">
                            <Grid container item xs={12}>
                                <Button
                                    color="default"
                                    variant="contained"
                                    className={classes.btnEdit}
                                    onClick={() => handleClickToEditForm(topic.id)}
                                >
                                    {translate.get('BUTTON.EDIT')}
                                </Button>

                                <Grid container item xs={9} alignItems="center">
                                    <Grid item xs={12}>
                                        <Typography className={classes.header} noWrap variant={'body2'}>
                                            {translate.get('LABEL.CONSIDER_TYPE')}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography className={classes.description} variant={'body2'}>
                                            {topic.name}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                )
            })}
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    titleContainer: {
        fontWeight: 'bold',
        marginLeft: '-22px',
    },
    paper: {
        padding: '24px',
        marginBottom: '10px',
        marginRight: '0px',
        marginTop: '40px',
        transition: '0.3s',
        borderRadius: '4px',
        position: 'relative',
        '&:hover': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    btnEdit: {
        height: '44px',
        minWidth: '0px',
        borderRadius: '4px',
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        textAlign: 'center',
        marginRight: '50px',
        fontSize: '16px',
    },
    header: {
        border: 'unset',
        fontWeight: 'bolder',
        fontSize: '16px',
    },
    description: {
        fontWeight: 'lighter',
        fontSize: '20px',
        width: '100%',
    },
}))

export default ManageCheckList
